import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { getMarketplaceSearchClient } from 'marketplace-ui-common/clients/marketplaceSearchClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from 'marketplace-ui-common/constants/search';
import { useCallback } from 'react';
import ProfileSearchBarResult from '../components/ProfileSearchBarResult';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO refactor
export function getSolutionsDirectoryUrl(appContext) {
  let urlRoot;
  if (appContext === 'app') {
    urlRoot = `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}`;
  } else {
    urlRoot = getFullUrl('ecosystem', {
      hubletOverride: 'na1'
    });
    const lang = getLang();
    switch (lang) {
      case 'de':
      case 'es':
      case 'fr':
      case 'ja':
      case 'pt':
        {
          urlRoot += `/${lang}`;
          break;
        }
      default:
        break;
    }
  }
  return `${urlRoot}/marketplace/solutions/all`;
}
export function useProfileSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  query = {}
} = {}) {
  const fetcher = useCallback(input => {
    const client = getMarketplaceSearchClient(appContext);
    const request = client.post('profiles/search', {
      data: [Object.assign({}, query, {
        limit,
        search: input
      })]
    });
    return request.then(([{
      items,
      total
    }]) => {
      const options = items.map(item => {
        const {
          id,
          logoUrl,
          name,
          partnerType,
          reviewSummary,
          slug,
          tier
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(ProfileSearchBarResult, {
            logoUrl: logoUrl,
            name: name,
            partnerType: partnerType,
            reviewSummary: reviewSummary,
            tier: tier
          }),
          href: `${getSolutionsDirectoryUrl(appContext)}/${slug}`,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `profile::${id}`
        };
      });
      if (total > limit) {
        options.push({
          href: `${getSolutionsDirectoryUrl(appContext)}?eco_search=${input}`,
          text: I18n.text('marketplace-ui-solutions-core.profileSearchBarViewAll', {
            total
          }),
          value: '__VIEW_ALL_PROFILES__'
        });
      }
      return options;
    }).then(options => grouped ? [{
      text: I18n.text('marketplace-ui-solutions-core.profileSearchBarGroupLabel'),
      options
    }] : options);
  }, [appContext, grouped, limit, query]);
  return {
    fetcher
  };
}